// extracted by mini-css-extract-plugin
export const card = "fixed-module--card--3CQEK";
export const thumbnail = "fixed-module--thumbnail--m39XG";
export const fullsize = "fixed-module--fullsize--M1g09";
export const data = "fixed-module--data--20yKR";
export const head = "fixed-module--head--cb1gZ";
export const info = "fixed-module--info--2LTB3";
export const flex = "fixed-module--flex--2Gof-";
export const tag = "fixed-module--tag---CQss";
export const bottom = "fixed-module--bottom--ckEti";
export const title = "fixed-module--title--2z4sr";
export const lead = "fixed-module--lead--2ILWY";